import { useEffect } from "react";

export const ActiveForm = ({ mode, setFieldValue, forms, children }) => {
  useEffect(() => {
    if (mode === "edit") {
      setFieldValue("files", forms[1].initialValues.files);
      setFieldValue("floorName", forms[1].initialValues.floorNames);
      setFieldValue("sites", forms[2].initialValues.sites);
    }
  }, []);
  return <>{children}</>;
};
